import { Rectangle } from '../math/rectangle';
import { ConsoleScreen } from './console-screen';
import { range } from '../math/util';

enum BoxCharType {
  // box drawing chars
  HLINE,
  VLINE,
  ULCORNER,
  URCORNER,
  LLCORNER,
  LRCORNER
}

export class ConsoleDraw {
  constructor(readonly screen: ConsoleScreen) {}

  drawBox(rectangle: Rectangle, style: BoxStyleType) {
    const box = this.getBox(style)

    const hLineChar = box.getBoxChar(BoxCharType.HLINE)
    const vLineChar = box.getBoxChar(BoxCharType.VLINE)

    const xs = range(rectangle.size.width-2).map(x => x + rectangle.p0.x + 1)
    const ys = range(rectangle.size.height-2).map(y => y + rectangle.p0.y + 1)

    xs.forEach(x => {
      this.screen.writeCharCode(hLineChar, x, rectangle.p0.y)
      this.screen.writeCharCode(hLineChar, x, rectangle.p1.y)
    })

    ys.forEach(y => {
      this.screen.writeCharCode(vLineChar, rectangle.p0.x, y)
      this.screen.writeCharCode(vLineChar, rectangle.p1.x, y)
    })

    this.screen.writeCharCode(box.getBoxChar(BoxCharType.ULCORNER), rectangle.p0.x, rectangle.p0.y)
    this.screen.writeCharCode(box.getBoxChar(BoxCharType.URCORNER), rectangle.p1.x, rectangle.p0.y)

    this.screen.writeCharCode(box.getBoxChar(BoxCharType.LLCORNER), rectangle.p0.x, rectangle.p1.y)
    this.screen.writeCharCode(box.getBoxChar(BoxCharType.LRCORNER), rectangle.p1.x, rectangle.p1.y)
  }

  protected getBox(style: BoxStyleType): Box {
    switch(style) {
      case BoxStyleType.DOUBLE: return new DoubleBox()
      case BoxStyleType.SINGLE: return new SingleBox()
    }
  }
}

export enum BoxStyleType {
  DOUBLE,
  SINGLE,
}

interface Box {
  getBoxChar(boxChar: BoxCharType): number
}

class DoubleBox implements Box {
  getBoxChar(boxChar: BoxCharType): number {
    switch (boxChar) {
      case BoxCharType.HLINE:    return 205
      case BoxCharType.VLINE:    return 186
      case BoxCharType.ULCORNER: return 201
      case BoxCharType.URCORNER: return 187
      case BoxCharType.LLCORNER: return 200
      case BoxCharType.LRCORNER: return 188
    }
  }
}

class SingleBox implements Box {
  getBoxChar(boxChar: BoxCharType): number {
    switch (boxChar) {
      case BoxCharType.HLINE:    return 196
      case BoxCharType.VLINE:    return 179
      case BoxCharType.ULCORNER: return 218
      case BoxCharType.URCORNER: return 191
      case BoxCharType.LLCORNER: return 192
      case BoxCharType.LRCORNER: return 217
    }
  }
}
